import React from 'react';
import PropTypes from 'prop-types';

import Header from '../header';
import Footer from '../footer';
import { rbrHeaderModel, rbrFooterModel } from '../../../models/layout';

const Layout = ({ children }) => (
  <>
    <Header authoring={rbrHeaderModel} />
    {children}
    <Footer authoring={rbrFooterModel} />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
